import React from 'react';
import { X, Check } from 'lucide-react';
const rows = [{
  label: 'Authentic resort flavors',
  book: true,
  restaurant: true,
  cookbook: false,
  class: true
}, {
  label: 'Cook from your home kitchen',
  book: true,
  restaurant: false,
  cookbook: true,
  class: false
}, {
  label: 'Ingredients from any US grocery store',
  book: true,
  restaurant: false,
  cookbook: false,
  class: false
}, {
  label: 'Ready in 30–45 minutes',
  book: true,
  restaurant: true,
  cookbook: false,
  class: false
}, {
  label: '30-day money-back guarantee',
  book: true,
  restaurant: false,
  cookbook: false,
  class: false
}, {
  label: 'Lifetime access — cook it forever',
  book: true,
  restaurant: false,
  cookbook: true,
  class: false
}];
const prices = [{
  label: 'This Playbook',
  value: '$6.39',
  accent: true
}, {
  label: 'Restaurant Dinner for 2',
  value: '$120+'
}, {
  label: 'Generic Cookbook',
  value: '$35'
}, {
  label: 'In-Person Cooking Class',
  value: '$400+'
}];
export function Comparison() {
  return <section className="w-full py-16 md:py-24 bg-white" data-id="element-152">
      <div className="max-w-5xl mx-auto px-6 md:px-12" data-id="element-153">
        <div className="text-center mb-12" data-id="element-154">
          <h2 className="text-4xl md:text-5xl text-[#3E2723] mb-4" data-id="element-155">
            Why Pay More for Less?
          </h2>
          <p className="text-xl text-[#3E2723]/70 max-w-2xl mx-auto" data-id="element-156">
            One playbook replaces the trip, the class, and the trial-and-error.
          </p>
        </div>

        <div className="bg-[#F5F1E8] rounded-2xl overflow-hidden shadow-lg border border-[#3E2723]/10" data-id="element-157">
          <div className="grid grid-cols-5 bg-[#3E2723] text-white text-xs md:text-base font-bold" data-id="element-158">
            <div className="p-3 md:p-5" data-id="element-159"></div>
            <div className="p-3 md:p-5 text-center bg-[#C2410C]" data-id="element-160">
              <div className="text-yellow-300" data-id="element-161">This Book</div>
              <div className="text-xs font-normal text-white/80 mt-1" data-id="element-162">
                $6.39
              </div>
            </div>
            <div className="p-3 md:p-5 text-center" data-id="element-163">
              <div data-id="element-164">Restaurant</div>
              <div className="text-xs font-normal text-white/70 mt-1" data-id="element-165">
                $120+
              </div>
            </div>
            <div className="p-3 md:p-5 text-center" data-id="element-166">
              <div data-id="element-167">Cookbook</div>
              <div className="text-xs font-normal text-white/70 mt-1" data-id="element-168">$35</div>
            </div>
            <div className="p-3 md:p-5 text-center" data-id="element-169">
              <div data-id="element-170">Cooking Class</div>
              <div className="text-xs font-normal text-white/70 mt-1" data-id="element-171">
                $400+
              </div>
            </div>
          </div>

          {rows.map((row, idx) => <div key={idx} className={`grid grid-cols-5 items-center text-sm md:text-base ${idx % 2 === 0 ? 'bg-white' : 'bg-[#FBF7F0]'}`} data-id="element-172">
              <div className="p-3 md:p-5 font-medium text-[#3E2723]" data-id="element-173">
                {row.label}
              </div>
              <div className="p-3 md:p-5 text-center bg-[#C2410C]/5" data-id="element-174">
                {row.book ? <Check className="w-5 h-5 md:w-6 md:h-6 text-[#14B8A6] mx-auto" data-id="element-175" /> : <X className="w-5 h-5 md:w-6 md:h-6 text-[#3E2723]/30 mx-auto" data-id="element-176" />}
              </div>
              <div className="p-3 md:p-5 text-center" data-id="element-177">
                {row.restaurant ? <Check className="w-5 h-5 md:w-6 md:h-6 text-[#14B8A6] mx-auto" data-id="element-178" /> : <X className="w-5 h-5 md:w-6 md:h-6 text-[#3E2723]/30 mx-auto" data-id="element-179" />}
              </div>
              <div className="p-3 md:p-5 text-center" data-id="element-180">
                {row.cookbook ? <Check className="w-5 h-5 md:w-6 md:h-6 text-[#14B8A6] mx-auto" data-id="element-181" /> : <X className="w-5 h-5 md:w-6 md:h-6 text-[#3E2723]/30 mx-auto" data-id="element-182" />}
              </div>
              <div className="p-3 md:p-5 text-center" data-id="element-183">
                {row.class ? <Check className="w-5 h-5 md:w-6 md:h-6 text-[#14B8A6] mx-auto" data-id="element-184" /> : <X className="w-5 h-5 md:w-6 md:h-6 text-[#3E2723]/30 mx-auto" data-id="element-185" />}
              </div>
            </div>)}
        </div>
      </div>
    </section>;
}